import styled from "styled-components";

export const StyledFooter = styled.div`
  background: #808080;

  section {
    padding: 60px 0;
  }
  h1 {
    font-weight: bold;
    font-size: 52px;
    line-height: 52px;
    color: white;
    cursor: pointer;
  }

  #footer h5 {
    padding-left: 10px;
    padding-bottom: 6px;
    margin-bottom: 20px;
    color: #ffffff;
  }
  #footer a {
    color: #ffffff;
    text-decoration: none !important;
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
  }

  #footer ul.quick-links li {
    padding: 3px 0;
    -webkit-transition: 0.5s all ease;
    -moz-transition: 0.5s all ease;
    transition: 0.5s all ease;
  }
  #footer ul.quick-links li:hover {
    padding: 3px 0;
    margin-left: 5px;
    font-weight: 700;
  }
  .bottomBar {
    width: 100%;
    border-top: 1px solid #979696;
    padding: 10px 0px;
    display: flex;
    justify-content: center;
    & p {
      color: white;
    }
  }

  @media (max-width: 767px) {
    #footer h5 {
      padding-left: 0;
      border-left: transparent;
      padding-bottom: 0px;
      margin-bottom: 10px;
    }
  }
`;
